//________________________________________________________________________________________________
//	This file contains the names of the conference events and documents each event's contents.
//
//	Notes:
//		- The conference events are triggered at the document level
//		- A conference event always contains a source component, for example VIL, DST or uScope.
//
var confEvent = {
    //............................................................................................
    // VIL issued events
    //............................................................................................
    // VIL fires a create event when it communicates conference start to the DSC server
    create: "cf_create"			// {src: "VIL", tbd: fill me in }

    // VIL fires a join message when the viewer is to enter conferencing mode
    // DST and uScope listen for this message and configure according to whether they are the leader or not
    , join: "cf_join"			// {src: "VIL", lead: {true,false}, userName: STR }

    // VIL fires a lead message when the leadership role changes
    // DST and uScope listen for this message and configure according to whether they are the leader or not
    , leadChange: "cf_lead"		// {src: "VIL", lead: {true,false} }

    // VIL fires an exit message when the viewer is exiting the conference
    // DST and uScope listen for this message and return to non-conference operation
    , exit: "cf_exit"			// {src: "VIL" } 

    //............................................................................................
    // uScope issued events
    //............................................................................................

    // as a conference leader, uScope fires the open or close event to report image open or close events
    // The leader uScope fires it, the follower uScope listens for it (issued by follower VIL)
    , openimage: "cf_openimage"		// {src: "uScope", imageId: @NUM, uScopeIdx: NUM, "imagePath": STR } 
    , closeimage: "cf_closeimage"	// {src: "uScope", imageId: @NUM } 


    // uScope fires a createBtn event when the user clicks the conference button on uScope's toolbar
    // VIL listens for it and creates the conference
    , createBtn: "cf_createBtn"	// {src: "uScope" } 

    // as a conference leader, uScope fires the marker event to report the user's cursor position
    , marker: "cf_marker"		// {src: "uScope", imageId: @NUM, uScopeIdx: NUM, "imagePath": STR, MarkerX: NUM, MarkerY: NUM } 
    ///	, Marker: "Marker"			// match event name with DSC client's string that filters out prior messages

    // as a conference leader, uScope fires the view event to report the view state changes
    // ! note that when multi-image is implemented this signature will probably expand to include all the open images
    , view: "cf_view"			// {src: "uScope", imageId: @NUM, uScopeIdx: NUM, "imagePath": STR, x: NUM, x: NUM, zoom: NUM, angleDeg: NUM } 
    ///	, Position: "Position"		// match event name with DSC client's string that filters out prior messages

    // as a conference follower, uScope listens for this event (issued by follower VIL)
    , update: "cf_update"		// {src: "uScope", imageId: @NUM, ... (contents of position or marker events } 

    // as a conference follower, uScope fires this event when its image has been changed
    // VIL listens for it and creates the conference
    , imageChange: "cf_imageChange"		// {src: "uScope", imageId: @NUM } 

};
